var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { unindent } from "./util";
(function () {
  var element = document.currentScript;
  if (!element) return;
  if (element.hasAttribute("data-turbolinks-suppress-warning")) return;
  while (element = element.parentElement) {
    if (element == document.body) {
      return console.warn(unindent(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        You are loading Turbolinks from a <script> element inside the <body> element. This is probably not what you meant to do!\n\n        Load your application\u2019s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.\n\n        For more information, see: https://github.com/turbolinks/turbolinks#working-with-script-elements\n\n        \u2014\u2014\n        Suppress this warning by adding a \"data-turbolinks-suppress-warning\" attribute to: %s\n      "], ["\n        You are loading Turbolinks from a <script> element inside the <body> element. This is probably not what you meant to do!\n\n        Load your application\u2019s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.\n\n        For more information, see: https://github.com/turbolinks/turbolinks#working-with-script-elements\n\n        \u2014\u2014\n        Suppress this warning by adding a \"data-turbolinks-suppress-warning\" attribute to: %s\n      "]))), element.outerHTML);
    }
  }
})();
var templateObject_1;